// extracted by mini-css-extract-plugin
export default {"popup":"CropImage_popup__PcrLm","cross":"CropImage_cross__9YF45","cropArea":"CropImage_cropArea__sSKGb","button":"CropImage_button__7fAdi"};